import type { FC } from "react";
import type { SvgIcons } from "../../type/Icons";

export const Send: FC<SvgIcons>=({fill,width="32", height="32"})=>{


    return (
        <>
    <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none" className="size-6"> <path fill="#ffffff" d="m3.755 15.576 15.622-6.555c1.542-.683 6.771-2.869 6.771-2.869s2.413-.955 2.213 1.366c-.067.955-.603 4.302-1.14 7.92L25.547 26.16s-.134 1.57-1.276 1.844c-1.141.273-3.016-.955-3.352-1.229-.268-.204-5.028-3.277-6.772-4.78-.469-.41-1.005-1.229.067-2.185 2.414-2.253 5.297-5.054 7.04-6.829.804-.82 1.61-2.732-1.743-.41l-9.454 6.487s-1.073.683-3.083.069-4.358-1.434-4.358-1.434-1.61-1.025 1.14-2.117h.002z"></path> </svg>
        </>
    )
}